import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';

export const Repeating = observer(({ alert }) => {
  return (
    <td>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Body3 fontWeight={500}>
          {alert.restartSystemOncePositionHasFlattened ? '🔄 ' : ''}
        </Body3>
      </div>
    </td>
  );
});

Repeating.propTypes = {
  alert: PropTypes.shape({
    restartSystemOncePositionHasFlattened: PropTypes.any,
  }),
};
